<template>
  <div></div>
</template>

<script>
export default {
  name: 'AssetsPage',
  mounted() {
    this.$router
      .push({
        name: 'AssetsAssets'
      })
      .catch((error) => {
        console.log(error)
      })
  }
}
</script>
